import React, { useEffect, useMemo, useState } from "react";

const PreventUnload = ({ children }) => {
  useEffect(() => {}, []);

  return <>{children}</>;
};

export default PreventUnload;
